import { useQuery } from '@apollo/client';
import { useState } from 'react';
import { gql } from '@/__generated__';
import { AiFilterTestInput } from '@/__generated__/graphql';
import { AiFilterEvaluation } from '@/__generated__/schema-types';

const AI_FILTER_EVALUATION_QUERY = gql(`
  query AiFilterEvaluation($filter: AIFilterTestInput!) {
    aiFilterEvaluation(filter: $filter) {
      comment
      qualityLevel
    }
  }
`);

export function useAiFilterEvaluation(filter: AiFilterTestInput) {
  const [aiFilterEvaluation, setAiFilterEvaluation] =
    useState<AiFilterEvaluation | null>(null);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState<Error | null>(null);
  const { refetch } = useQuery(AI_FILTER_EVALUATION_QUERY, {
    variables: { filter },
    skip: true,
    onCompleted: (data) => {
      if (data) {
        setAiFilterEvaluation(data.aiFilterEvaluation);
      }
    },
  });

  const evaluateFilter = async (filter: AiFilterTestInput) => {
    try {
      setError(null);
      setIsLoading(true);
      await refetch({ filter });
    } catch (error) {
      setError(error as Error);
    } finally {
      setIsLoading(false);
    }
  };

  return {
    evaluateFilter,
    aiFilterEvaluation,
    error,
    isLoading,
  };
}
